define(["require", "exports", "jquery", "./context", "./contactus", "./analytics", "./debounce"], function (require, exports, $, context_1, contactus_1, analytics_1, debounce_1) {
    "use strict";
    exports.__esModule = true;
    function closeSideMenu(e) {
        e.preventDefault();
        e.stopPropagation();
        $('.icon-menu').toggleClass('open', false).toggleClass('closed', true);
        $('body').toggleClass('no-scroll', false);
    }
    $(function () {
        $('.topmenu').on('click', 'li', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var $ul = $(e.currentTarget);
            analytics_1["default"]('menu', 'click', $ul.text());
            window.location.href = $ul.find('a:first').attr('href');
        });
        $('.header.customize .headermenu.icon-menu').click(debounce_1["default"](function (evt) {
            evt.preventDefault();
            evt.stopPropagation();
            $(evt.currentTarget).toggleClass('closed');
        }, 100, true));
        if (context_1["default"].isMobile()) {
            $('ul.topmenu').prepend('<div class="close-button"></div>');
            $(".topmenu .close-button").click(function (e) {
                analytics_1["default"]('menu', 'close');
                closeSideMenu(e);
            });
            $('ul.topmenu li:last-child ul').append('<li><a href="#contactus" id="mobileContactUs">Contact us</a></li>');
            $('#mobileContactUs').parent().click(function (e) {
                e.preventDefault();
                e.stopPropagation();
                contactus_1.mobileContactUs();
                closeSideMenu(e);
            });
            $('.icon-menu').click(function (e) {
                e.preventDefault();
                e.stopPropagation();
                var $cur = $(e.currentTarget);
                var isOpen = $cur.toggleClass('open closed').hasClass('open');
                if (isOpen) {
                    if (context_1["default"].isMobile()) {
                        $('.attribute-panel.shown').toggleClass('shown', false);
                    }
                }
                $('body').toggleClass('no-scroll', isOpen);
                if (isOpen) {
                    analytics_1["default"]('menu', 'open');
                    $(window).scrollTop(0);
                }
            });
        }
    });
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/sideMenu.js
// module id = 73
// module chunks = 0